import { createSelector } from "reselect"

import { getPathForLang } from "./routesLangs"

const optionsSelector = state => state.options

export default createSelector(
  [optionsSelector],
  options => path => getPathForLang(path, options.get("language")),
)
